'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var listenerMessageChannel = require('message-channel/listener');
var greedySplit = require('greedy-split');
var BaseStorage = require('../base-storage');
var LocalStorageStrategy = require('../strategies/local-storage');

var FrameStorageListener = function () {
  function FrameStorageListener() {
    var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new LocalStorageStrategy();

    _classCallCheck(this, FrameStorageListener);

    this.storageStrategy = BaseStorage.verify(strategy);
    this.stopListener;
  }

  _createClass(FrameStorageListener, [{
    key: 'start',
    value: function start(verifier, interceptor) {
      if (!verifier || typeof verifier !== 'function') {
        throw new Error('start function must get a verifier function as a first argument');
      }

      if (interceptor && typeof interceptor !== 'function') {
        throw new Error('the interceptor must be a function');
      }

      var storageStrategy = BaseStorage.verify(this.storageStrategy);
      this.stopListener = listenerMessageChannel('data-capsule', messageHandler);

      function messageHandler(e, reply) {
        if (typeof e.data !== 'string') {
          return;
        }

        var _greedySplit = greedySplit(e.data, '|', 3),
            _greedySplit2 = _slicedToArray(_greedySplit, 3),
            token = _greedySplit2[0],
            method = _greedySplit2[1],
            payload = _greedySplit2[2];

        var respond = function respond(status, data) {
          if (status === 'resolve') {
            var _response = [status, JSON.stringify({ data: data })].join('|');
            return reply(_response);
          }

          var response = [status, data].join('|');
          return reply(response);
        };

        if (!verifier(e.source, e.origin, token)) {
          return respond('reject', 'message was not authorized');
        }

        var invoke = storageStrategy[method].bind(storageStrategy);

        var params = JSON.parse(payload).data;
        var options = params[params.length - 1];

        var modifiedOptions = interceptor ? interceptor(options, e.source, e.origin, token) : options;
        params[params.length - 1] = modifiedOptions;

        return invoke.apply(undefined, _toConsumableArray(params)).then(function (result) {
          return respond('resolve', result);
        }).catch(function (error) {
          return respond('reject', error.message || error);
        });
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.stopListener && this.stopListener();
    }
  }]);

  return FrameStorageListener;
}();

module.exports = FrameStorageListener;